import React from 'react';
import { Placeholder } from '../../primitives/Placeholder';
import { Line } from '../primitives';
import { cx } from '@linaria/core';
import { Typo } from '../../primitives/Typo';
import { LiveOverline } from '../TeaserText/styles';
function ProgramInformation({ teaserType, programDate, programTime, isLoading }) {
    /** JSX */
    return isLoading ? (React.createElement("div", { className: cx(Line.base, Typo.base, Typo.info01) },
        React.createElement("span", { className: cx(Placeholder.base), style: { width: '3rem' } }))) : (React.createElement("div", { className: cx(Line.base, Typo.base, Typo.info01, teaserType === 'live' && LiveOverline.base) },
        programDate,
        programDate && programTime && ' ・ ',
        programTime && React.createElement(React.Fragment, null,
            programTime,
            " Uhr")));
}
export default ProgramInformation;
